import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Toaster } from "sonner";
import LoginPage from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Anagrafiche from "@/pages/Anagrafiche";
import Clienti from "@/pages/Clienti";
import Magazzino from "@/pages/Magazzino";
import Movimenti from "@/pages/Movimenti";
import Ordini from "@/pages/Ordini";
import Personalizzazioni from "@/pages/Personalizzazioni";
import Profilo from "@/pages/Profilo";
import Impostazioni from "@/pages/Impostazioni";
import Calendario from "@/pages/Calendario";

function LoaderScreen() {
  return (
    <div className="loader-screen">
      <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 12 }}>
        <div className="spin" />
        <div>Caricamento GymERP…</div>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <LoaderScreen />;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user, checking } = useAuth();
  if (checking) return <LoaderScreen />;
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/login" element={<PublicOnly><LoginPage /></PublicOnly>} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/anagrafiche" element={<Protected><Anagrafiche /></Protected>} />
      <Route path="/clienti" element={<Protected><Clienti /></Protected>} />
      <Route path="/magazzino" element={<Protected><Magazzino /></Protected>} />
      <Route path="/movimenti" element={<Protected><Movimenti /></Protected>} />
      <Route path="/ordini" element={<Protected><Ordini /></Protected>} />
      <Route path="/personalizzazioni" element={<Protected><Personalizzazioni /></Protected>} />
      <Route path="/calendario" element={<Protected><Calendario /></Protected>} />
      <Route path="/profilo" element={<Protected><Profilo /></Protected>} />
      <Route path="/impostazioni" element={<Protected><Impostazioni /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <AppRoutes />
          <Toaster position="bottom-right" richColors closeButton />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
